module.exports = __webpack_public_path__ + "static/media/map2.848cdaa5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/map2.svg
 ** module id = 462
 ** module chunks = 0
 **/